import { FC } from "react";

import { Icon, MenuButton } from "../../../general";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly onClear?: () => void;
}

/** The header branding mark, which doubles as the chat-level options menu when actions are available. */
export const ChatHeaderMenu: FC<Props> = ({ styles, onClear }) => {
  if (!onClear) {
    return (
      <span className={styles.ChatHeaderLogo} aria-hidden="true">
        <Icon name="message-dots" />
      </span>
    );
  }

  return (
    <span className={styles.ChatHeaderMenu}>
      <MenuButton
        appearance="text"
        size="large"
        icon="message-dots"
        caretIcon={false}
        aria-label="Chat options"
        testId="chatbot-options"
      >
        <MenuButton.Item onClick={onClear} aria-label="Clear conversation">
          <span className={styles.ChatHeaderMenuItem}>
            <Icon name="delete" className={styles.ChatHeaderMenuItemIcon} aria-hidden="true" />
            Clear conversation
          </span>
        </MenuButton.Item>
      </MenuButton>
    </span>
  );
};
